import axios from 'axios';

// Create axios instance with default config
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://localhost:5099',
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true  // Important for Safari cookie handling
});

// Add request interceptor to handle token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // If error is 401 and not a retry attempt, try to refresh token
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        // Attempt to refresh token
        const refreshToken = localStorage.getItem('refreshToken');
        
        if (refreshToken) {
          // Fix path: Don't add /api/ if the baseURL already includes the domain
          const refreshPath = api.defaults.baseURL.includes('rocketscanner.com') 
            ? '/auth/refresh-token' 
            : '/api/auth/refresh-token';
            
          const res = await axios.post(`${api.defaults.baseURL}${refreshPath}`, {
            refreshToken
          });
          
          const { token } = res.data;
          localStorage.setItem('token', token);
          
          // Update auth header with new token
          api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          originalRequest.headers['Authorization'] = `Bearer ${token}`;
          
          // Retry the original request with new token
          return api(originalRequest);
        }
      } catch (refreshError) {
        // If refresh fails, redirect to login
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;
